import { createContext, useContext } from "react";

export type DocumentType = 'renewal-notice' | 'debit-note' | 'annuity-certificate' | 'certificate' | 'other'

export type DocumentInfo = {
    id: string;
    created: string;
    filename: string;
    type: DocumentType;
}

export const DocumentContext = createContext({
    info: {} as DocumentInfo,
    download: () => Promise.resolve({})
})

export function useDocumentContext() {
    return useContext(DocumentContext)
}

export const IpRightsDocuments = createContext({
    documents: [] as DocumentInfo[],
    download: (id: string, filename: string) => Promise.resolve({}),
})

export function useIpRightDocuments() {
    return useContext(IpRightsDocuments)
}